import o from "./CdrLabelStandalone.vue2.mjs";
import s from "./styles/CdrLabelStandalone.module.scss.mjs";
import t from "../../../_virtual/_plugin-vue_export-helper.mjs";
const e = {
  $style: s
}, a = /* @__PURE__ */ t(o, [["__cssModules", e]]);
export {
  a as default
};
